<template>
  <span>
    <aha-antd-button
      v-aha-emit-action
      name="preview-presentation-button"
      :disabled="isNewPresentation"
      variant="secondary"
      @click="openPresentationPreview()"
      v-tooltip="$i18nPresenter.t('Test and interact with your slides')"
    >
      <!-- <i class="fas fa-eye" /> -->
      <span>{{ $i18nPresenter.t('Preview') }}</span>
    </aha-antd-button>

    <AhaModal
      hide-header
      size="full-screen"
      v-if="isPreview"
    >
      <PresentationPlayDemo
        @close="closePresentationPreview()"
        :preview-presentation-id="presentation.id"
        :preview-presentation-unique-access-code="presentation.uniqueAccessCode"
      />
    </AhaModal>
  </span>
</template>

<script>
import { mapState } from 'vuex'

import Utils from '@/util'
import constants from '@/constant'
import {
  SET_CURRENT_SLIDE_MODE,
  EDIT_MODE,
} from '@/vuex/types'
import EventBus from '@/eventBus'

// components
import PresentationPlayDemo from '@/components-v2/presentation-play-demo/PresentationPlayDemo.vue'

export default {
  components: {
    PresentationPlayDemo,
  },
  computed: {
    ...mapState({
      isPreview: (state) => state.isPreview,
      presentation: (state) => state.presentation,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      isNewPresentation: (state) => state.isNewPresentation,
      currentUser: (state) => state.currentUser,
    }),
  },
  mounted() {
    EventBus.$on('closePresentationPreview', this.closePresentationPreview)
  },
  destroyed() {
    this.$store.state.isPreview = false
    EventBus.$off('closePresentationPreview')
  },
  methods: {
    async closePresentationPreview() {
      EventBus.$emit('getDataPresentationDetail', null, 'closePresentationPreview')
      this.$store.state.isPreview = false
      this.$router.replace({ query: {} })
      this.$store.dispatch(SET_CURRENT_SLIDE_MODE, EDIT_MODE)
    },
    async openPresentationPreview() {
      if (this.presentation.takenOverBy !== this.currentUser.id) {
        EventBus.$emit('take-over-event')
      }
      this.$store.state.isPreview = true
      this.$router.replace({ query: { preview: 'true' } })
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Presentation Preview > Open')
    },
  },
}
</script>
